export const bankAccountKeys = {
	list: (params: { guestId: number; locationId: number }) => [
		"bank-accounts",
		params,
	],
};
